module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-21.e3fc2aa0.svg";